import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Header from '@/components/Header';
import { ChildrenProps } from '@/interfaces';
import { useAppSelector } from '@/store/hooks';
import GeneralOverlay from './components/GeneralOverlay';
import { toggleMobileMenu } from '@/features/ui/sliceMobileMenu';

import { book } from '@/routers/books';
import BannerAds from '@/components/BannerAds';
import { cn } from '@/lib/utils';

interface IGeneralLayout extends ChildrenProps {
  projectNavigation: ReactNode;
  isAuth?: boolean;
}

const Layout = ({ children, projectNavigation, isAuth }: IGeneralLayout) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { isMobileMenu } = useAppSelector(({ ui }) => ({
    isMobileMenu: ui.isMobileMenu,
  }));

  useEffect(() => {
    dispatch(toggleMobileMenu(false));
  }, [pathname, dispatch]);

  let clearPath = pathname;
  if (clearPath.endsWith('/') && clearPath !== '/') {
    clearPath = clearPath.slice(0, -1);
  }

  if (!isAuth && clearPath !== book.invoices.invoice
    && clearPath !== book.invoices.confirmEmail
    && clearPath !== book.invoices.invoiceCompleted) {
    return null;
  }

  return (
    <div className="flex min-h-screen">
      {/* left menu */}
      {isAuth && projectNavigation}
      <main className="flex-grow min-w-0 transition-transform duration-700 relative md:max-h-screen md:overflow-auto">
        <Header />
        <div
          className={cn(
            'py-12 px-6 max-[920px]:px-2.5',
            isMobileMenu && 'opacity-90 scale-95 pointer-events-none z-0'
          )}
        >
          {!clearPath.includes(book.invoices.invoice) && <BannerAds />}
          {children}
        </div>
        {isMobileMenu && <GeneralOverlay />}
      </main>
    </div>
  );
};

export default Layout;
